'use es6';

import { createContext } from 'react';

const noopFn = () => {};

export default /*#__PURE__*/createContext({
  app: null,
  name: null,
  addMessageListener: noopFn,
  removeMessageListener: noopFn,
  sendMessage: noopFn,
  sendBroadcastMessage: noopFn,
  pageName: null,
  siteDomain: null
});